module.exports = __webpack_public_path__ + "img/no-image-available-icon.855e8ca0.png";